"use client";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useModal } from "@/stores/use-modal-store";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Text } from "@/components/ui/text";
import { X } from "lucide-react";

export const DynamicConfirmationModal = () => {
  const { isOpen, type, data, onClose } = useModal();
  const { confirmationTitle, confirmAction, desc, confirmButton, icon, confirmButtonVariant } =
    data;
  const [loading, setLoading] = useState(false);

  const isModalOpen = isOpen && type === "dynamicConfirmationModal";

  const handleClose = () => onClose();

  return (
    <Dialog open={isModalOpen} onOpenChange={handleClose}>
      <DialogContent
        isShowCloseBtn={false}
        className="max-w-full w-[90%] sm:w-[400px] p-4 overflow-visible"
        aria-labelledby="dialog-title"
      >
        <DialogHeader>
          <DialogTitle className="flex justify-start items-center gap-[10px] relative w-full">
            {icon}
            <Text className="whitespace-nowrap">{confirmationTitle}</Text>
            <X size={18} onClick={handleClose} className="absolute right-0 cursor-pointer"></X>
          </DialogTitle>
        </DialogHeader>
        <Text className="text-[#4F4F4F]">{desc}</Text>
        <div className="flex gap-5 justify-end items-center  w-full">
          <Button
            disabled={loading}
            loading={loading}
            loaderProps={{ size: "xs" }}
            onClick={confirmAction}
            type="button"
            variant={confirmButtonVariant as any}
          >
            {confirmButton}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
